import React, { useEffect, useState } from "react";
import { IconBack } from "../../assets/icon";
import TabDetailDashboardSurvey from "../../components/common/Tabs/TabDetailDashboardSurvey";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import queryString from "query-string";
import TabQuestionSurvey from "../../components/common/Tabs/TabQuestionSurvey";
import SelectValue from "../../components/common/Selector/SelectValue";
import { DatePicker, Tooltip } from "antd";
import TabPersonalDetails from "../../components/common/Tabs/TabPersonalDetails";
import moment from "moment";
const SurveyDetail = () => {
  // const [tabActive, setActive] = useState(1);
  const [datapost, setDataPost] = useState("");
  const navigate = useNavigate();
  const formatDate = "DD/MM/YYYY";
  const optionTime = [
    { value: "Tất cả", label: "Tất cả" },
    { value: 1, label: "1 tuần trước" },
    { value: 2, label: "1 tháng trước" },
    { value: 3, label: "6 tháng trước" },
    { value: -1, label: "Khoảng thời gian" },
  ];
  const [config, setConfig] = useState();
  const location = useLocation();
  // Lấy dữ liệu từ chuỗi truy vấn
  useEffect(() => {
    const params = queryString.parse(location.search);
    setConfig(params);
    setDataPost({
      timeStart: params.timeStart ? moment(params.timeStart) : null,
      timeEnd: params.timeEnd ? moment(params.timeEnd) : null,
    });
  }, [location.search]);

  const handleChangeDate = (field, date) => {
    const formatDate = date
      ? moment(date).format(
          field === "timeStart" ? "YYYY-MM-DD 00:00:00" : "YYYY-MM-DD 23:59:59"
        )
      : null;
    const updateParams = {
      ...config,
      [field]: formatDate,
    };
    navigate(
      `/survey_statistics_detail?${queryString.stringify(updateParams)}`
    );
    setDataPost({
      ...datapost,
      [field]: date ? moment(date) : null,
    });
  };
  const handleChangeTab = (value) => {
    navigate(
      `/survey_statistics_detail?${queryString.stringify({
        ...config,
        keyTab: value,
      })}`
    );
  };
  const handleChangeOptionTime = (value) => {
    const updateParams = {
      ...config,
      optionTime: value,
    };
    navigate(
      `/survey_statistics_detail?${queryString.stringify(updateParams)}`
    );
    setDataPost({
      ...datapost,
      optionTime: value,
    });
  };

  return (
    <div className="wrapperSurveyStatistics wrapperDetail">
      <div className="headerDetail">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/survey_statistics")}
        >
          <Tooltip
            title="Quay lại"
            overlayClassName="customerTooltip"
            style={{ backdropFilter: "blur(10px)" }}
            placement="topLeft"
          >
            <span style={{ cursor: "pointer" }}>
              <IconBack />
            </span>
          </Tooltip>
        </div>
        <span className="titleHeader">
          Thống kê cuộc khảo sát:{" "}
          <span style={{ color: "#FF6B00" }}>{config?.nameSurvey}</span>
        </span>
      </div>
      {Number(config?.typeSurvey) === 1 ? (
        <div className="headerTabDetail ">
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="label">Thời gian</span>
            <SelectValue
              width={171}
              defaultValue={"Tất cả"}
              style={{ marginRight: "4rem" }}
              type={"selectGray"}
              optionsValue={optionTime}
              // onChange={handleChangeOptionTime}
            />
            <span className="label">Từ</span>
            <DatePicker
              className="selectGray"
              format={formatDate}
              style={{ marginRight: "1.6rem" }}
              value={datapost.timeStart}
              onChange={(date) => {
                handleChangeDate("timeStart", date);
              }}
              placeholder="Chọn thời gian"
            />
            <span className="label">đến</span>
            <DatePicker
              className="selectGray"
              format={formatDate}
              value={datapost.timeEnd}
              onChange={(date) => {
                handleChangeDate("timeEnd", date);
              }}
              placeholder="Chọn thời gian"
            />
          </div>
        </div>
      ) : null}
      <div className="tabDetail">
        <div
          onClick={() => handleChangeTab(1)}
          className={`itemTabdetail ${
            Number(config?.keyTab) === 1 ? "tabActive" : null
          }`}
        >
          Tổng quan
        </div>
        <div
          onClick={() => handleChangeTab(2)}
          className={`itemTabdetail ${
            Number(config?.keyTab) === 2 ? "tabActive" : null
          }`}
        >
          Câu hỏi
        </div>
        <div
          onClick={() => handleChangeTab(3)}
          className={`itemTabdetail ${
            Number(config?.keyTab) === 3 ? "tabActive" : null
          }`}
        >
          Cá nhân
        </div>
      </div>
      {Number(config?.keyTab) === 1 ? (
        <TabDetailDashboardSurvey config={config} />
      ) : null}
      {Number(config?.keyTab) === 2 ? (
        <TabQuestionSurvey config={config} />
      ) : null}
      {Number(config?.keyTab) === 3 ? (
        <TabPersonalDetails config={config} />
      ) : null}
    </div>
  );
};

export default SurveyDetail;
